export const ROUTE_CONSTANTS = {
	HOME_PAGE: '/',
	DASHBOARD: '/dashboard',
	LOGIN_PAGE: '/login',
	ORDERS: '/orders',
	MENU: '/menu',
	FOOD_LIST: '/menu/items',
	ADD_EDIT_ITEM: '/menu/item',
	RE_ORDER_ITEM: '/reorder',
};

export const ROUTE_NAMES = {
	HOME_PAGE: 'Dashboard',
	LOGIN_PAGE: 'Login',
	ORDERS: 'Orders',
	MENU: 'Menu',
	FOOD_LIST: 'Menu Items',
	ADD_EDIT_ITEM: 'Menu Item',
	RE_ORDER_ITEM: 'Re-Order',
	NOT_FOUND: 'Not Found',
};
